var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"trigger"},_vm._l((_vm.loaders),function(i){return _c('v-card',{key:i},[_c('v-skeleton-loader',{staticClass:"mb-5",attrs:{"type":"list-item-avatar-two-line, article, actions"}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }